import React from 'react';
import clsx from 'clsx';

import PropTypes from 'prop-types';

import {makeStyles} from '@material-ui/styles';
import {Button, Grid, Typography} from '@material-ui/core';

import donorService from 'services/donor';

const useStyles = makeStyles(() => ({
  root: {}
}));

function Header({className, ...rest}) {
  const classes = useStyles();

  function handleClick(event) {
    event.preventDefault();

    donorService.downloadTempalet();
  }

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        alignItems="center"
        container
        justify="space-between"
        spacing={3}
      >
        <Grid
          item
          md={6}
          xs={12}
        >
          <Typography
            component="h2"
            gutterBottom
            variant="overline"
          >
            Donatur
          </Typography>
          <Typography
            component="h1"
            gutterBottom
            variant="h3"
          >
            Upload Donatur
          </Typography>
        </Grid>
        <Grid item>
          <Button
            color="primary"
            variant="contained"
            onClick={handleClick}
          >
            Template
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
